import filterConstants from '../constants';

const reportsProgressMilestone = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsProgressMilestone,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.portfolio_id]: '',
  },
});

export default reportsProgressMilestone;
